import { createFileRoute } from "@tanstack/react-router";
import AdminDistributors from "@/pages/admin/AdminDistributors";

export const Route = createFileRoute("/_adminLayout/admin/parts/distributors/")({
  component: AdminDistributors,
});